var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-12 col-md-auto order-3 order-md-2 d-none d-md-block"},[_c('div',{staticClass:"v-navbar-navigation d-flex d-print-none justify-content-start flex-grow-1"},[_c('nav',{staticClass:"d-flex justify-content-around"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }